<template>
    <QrWrapper>
        <div class="h-full flex flex-col max-w-xl mx-auto">
            <div class="flex mt-24">
                <LogoImage full class="mx-auto h-16 mb-4"/>
            </div>

            <QrForm @submit.prevent="forgotPassword" class="space-y-4 px-6 py-5 sm:p-6 mt-2">
                <QrInput v-model="email" disabled :label="trans('input.email')" type="email" :errors="validationErrors.email"/>
                <QrInput v-model="password" :label="trans('input.password')" type="password" :errors="validationErrors.password"/>
                <QrInput v-model="passwordConfirmation" :label="trans('input.confirm-password')" type="password" :errors="validationErrors.password_confirmation"/>

                <div class="flex justify-between space-x-4">
                    <QrLink to="/login" :text="trans('button.go-back')" trans="button.go-back" icon="arrow-left" secondary class="mt-1"/>
                    <QrButton
                        type="submit"
                        :loading="loading"
                        :recently-failed="recentlyFailed"
                        :recently-succeeded="recentlySucceeded"
                        :text="trans('button.update-password')" trans="button.update-password"
                        icon-right="arrow-right"
                    />
                </div>
            </QrForm>
        </div>
    </QrWrapper>
</template>

<script setup>
import QrInput from "@/components/application-ui/form/QrInput.vue";
import QrButton from "@/components/application-ui/elements/QrButton.vue";
import {onMounted, ref} from "vue";
import {getQueryParam, trans} from "@/libs/helper.js";
import { useUserStore } from "@/store/user.js";
import { useStatesStore } from "@/store/states.js";
import { storeToRefs } from "pinia";
import QrHeader from "@/components/application-ui/content/QrHeader.vue";
import {useRouter} from "vue-router";
import QrForm from "@/components/application-ui/content/QrForm.vue";
import QrIcon from "@/components/application-ui/elements/QrIcon.vue";
import TranslateText from "@/components/TranslateText.vue";
import QrParagraph from "@/components/application-ui/content/QrParagraph.vue";
import QrLink from "@/components/application-ui/content/QrLink.vue";
import Message from "@/components/application-ui/feedback/Message.vue";
import QrWrapper from "@/components/application-ui/panels/QrWrapper.vue";
import LogoImage from "@/components/LogoImage.vue";

const userStore = useUserStore();
const satesStore = useStatesStore();

const router = useRouter();
const token = ref('');
const email = ref('');
const password = ref('');
const passwordConfirmation = ref('');
const { loading, recentlySucceeded, recentlyFailed, validationErrors } = storeToRefs(satesStore);

const forgotPassword = async () => {
    const payload = {
        email: email.value,
        password: password.value,
        password_confirmation: passwordConfirmation.value,
        token: token.value,
    };

    await userStore.resetPassword(payload, async () => {
        await router.push({ name: 'login', query: {
            email: email.value,
            newPassword: 1,
        }})
    });
};

onMounted(() => {
    email.value = getQueryParam('email');
    token.value = getQueryParam('token');
})
</script>
